<script lang="ts" setup>
import type { TaskForm } from '~/types/Task'
import {EXECUTION_LOCATION} from "~/constants/task"; //TODO: Получать список с бэка
import CategoriesSelectModal from "~/components/pages/office/customer/orders/CategoriesSelectModal.vue";
const { t } = useI18n()
const props = defineProps({
    modelValue: {
        type: Object as PropType<TaskForm>,
        required: true
    },
    onlySpecificationIds: {
        type: Array as PropType<Number[]>,
    },
});

const emit = defineEmits(['update:modelValue']);

const localModel = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
});

const datesPlaceholder = computed(() => {
    let placeholder = t('Not set')

    if(localModel.value?.date?.from) {
        placeholder = $formatDateTime(localModel.value.date.from, 'MMM dd, yyyy')
    }
    if(localModel.value?.date?.to) {
        placeholder += ' - ' + $formatDateTime(localModel.value.date.to, 'MMM dd, yyyy')
    }
    
    return placeholder
})

const executionLocationOptions = computed(() => {
    return EXECUTION_LOCATION.map(item => ({
        value: item.id,
        label: item.name
    }))
})

</script>

<template>
    <div>
        <div class="mb-4">
            <CategoriesSelectModal rules="required" name="specification" v-model="localModel.specification" :onlySpecificationIds="onlySpecificationIds" />
            <UiErrorMessage class="text-[13px] text-red-500" name="specification" />
        </div>
        <div class="mb-4">
            <UiFormField rules="required" v-slot="{ componentField }" name="name">
                <UiInput class="rounded-xl input-type" v-model="localModel.name" :placeholder="$t('Short task name')" v-bind="componentField" maxlength="160" />
                <UiFormMessage class="mt-2" />
            </UiFormField>
        </div>
        <div class="mb-4">
            <UiFormField rules="required|max:200" v-slot="{ componentField }" name="description">
                <UiTextarea class="resize-none text-sm" v-model="localModel.description" maxlength="200"
                    :placeholder="$t('Tell us more about the task')" v-bind="componentField">
                </UiTextarea>
                <UiFormMessage class="mt-2" />
            </UiFormField>
        </div>
        <div class="mb-4">
            <CustomUiInputSelect :options="executionLocationOptions" :name="'execution_location'" v-model="localModel.execution_location" :label="$t('Task execution location')" :placeholder="$t('Select location')" :required="true" />
            <!-- <UiFormField rules="required" v-slot="{ componentField }" name="execution_location">
                <label class="text-sm font-medium">{{ $t("Task execution location") }}</label>
                <UiSelect v-model="localModel.execution_location" v-bind="componentField">
                    <UiSelectTrigger class="flex justify-between rounded-xl">
                        <Icon size="18" class="mr-2" name="ri:user-location-line" />
                        <UiSelectValue class="mr-auto" :placeholder="$t('Select location')" />
                    </UiSelectTrigger>
                    <UiSelectContent class="rounded-xl">
                        <UiSelectGroup>
                            <UiSelectItem class="rounded-xl" v-for="item in EXECUTION_LOCATION" :value="item.id">
                                {{ item.name }}
                            </UiSelectItem>
                        </UiSelectGroup>
                    </UiSelectContent>
                </UiSelect>
                <UiFormMessage class="mt-2" />
            </UiFormField> -->
        </div>
        <div class="mb-2 grid sm:grid-cols-2 gap-6">
            <div>
                <label class="text-sm font-medium mb-2">{{ $t("Due dates") }}</label>
                <CustomUiRangeCalendar start-field-name="date.from" end-field-name="date.to"
                    v-model:start="localModel.date.from" v-model:end="localModel.date.to"
                    :placeholder="datesPlaceholder || $t('Starting and ending date')" />
            </div>
            <div>
                <label class="text-sm font-medium mb-2">{{ $t("Budget") }}</label>
                <div>
                        <UiFormField v-slot="{ componentField }" name="budget.to">
                            <UiInput :placeholder="$t('Up to')" v-model="localModel.budget.to"
                                class="bg-gray-50 text-gray-700 rounded-xl [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" type="number" :min="0" :max="1000000"
                                v-bind="componentField" />
                                <UiFormMessage class="mt-2" />
                        </UiFormField>
                </div>
            </div>
        </div>
        <UiAlert class="border-0 bg-white w-full p-0 text-gray-500">
            <UiAlertDescription class="flex items-center">
                <Icon size="15" class="mr-1" name="ri:error-warning-fill" />
                <span class="text-xs font-[400]">{{ $t("Leave blank if terms are negotiable") }}</span>
            </UiAlertDescription>
        </UiAlert>
    </div>
</template>